// extracted by mini-css-extract-plugin
export default {"image":"animation_image__c-1gK","animate":"animation_animate__GTTeM"};